import * as React from 'react'

export default () => (
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="6.5" cy="6.5" r="5" fill="#CED0D4" stroke="#F5FAFE" strokeWidth="2" />
  </svg>
)
